
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"28","stroke":"#303D4E","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.416 27H1.092l4.4-12.329M30.876 14l4.883 13H11.224M29.111 9.3L25.993 1H10.37L7.408 9.3M9.372 16.666l-2.787 9.846","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.47 9.3l1.415-5.03.92-3.27M27.092 14.671l2.808 10.01M25.558 9.3L23.186 1M18.425 21.385v-6.714M18.425 9.3V4.662M12.88 4.27h11.039M8.416 21.726h20.019","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.876 9.3H5.486v5.371h25.39v-5.37z","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    